import { z } from "zod";
import { GasPrice } from "../business_central.js";
export const ListGasPricesRequestSearchParams = z
    .object({
    dateFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    dateTo: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
})
    .meta({ ref: "ListGasPricesRequestSearchParams" });
export const ListGasPricesResponseBody = z
    .object({
    gasPrices: z.array(GasPrice),
})
    .meta({ ref: "ListGasPricesResponseBody" });
